import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

export default function LayoutAddition() {
  return <ReactQueryDevtools buttonPosition="bottom-right" />;
}
